import { carbonSurveysStore } from "../stores";

export const useCarbonSurveysStore = () => carbonSurveysStore;
